// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__afok8","iconWithCounter":"styles_iconWithCounter__lR1qa","counterForLabel":"styles_counterForLabel__AaaMS","counterForIcon":"styles_counterForIcon__ow94Q"};